import { render, staticRenderFns } from "./Step4Confirm.vue?vue&type=template&id=23ede40a&scoped=true"
import script from "./Step4Confirm.vue?vue&type=script&lang=js"
export * from "./Step4Confirm.vue?vue&type=script&lang=js"
import style0 from "./Step4Confirm.vue?vue&type=style&index=0&id=23ede40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ede40a",
  null
  
)

export default component.exports